import type { ReactNode } from 'react';
import { useAuthStore } from '../stores/authStore';
import { getPermLevel } from '../lib/permissions';

interface PermissionGateProps {
  required: string[];
  children: ReactNode;
}

export function PermissionGate({ required, children }: PermissionGateProps) {
  const role = useAuthStore((s) => s.role);
  const userPerm = getPermLevel(role);
  const allowed = required.includes(userPerm);

  if (!allowed) return null;

  return <>{children}</>;
}
